// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Common = require("../utils/Common.bs.js");
var MM_parser = require("../mm-utils/MM_parser.bs.js");
var MM_provers = require("../mm-utils/MM_provers.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var MM_wrk_client = require("./MM_wrk_client.bs.js");
var MM_substitution = require("../mm-utils/MM_substitution.bs.js");
var MM_wrk_ctx_data = require("./MM_wrk_ctx_data.bs.js");

var procName = "MM_wrk_ctx";

function reqToStr(req) {
  switch (req.TAG | 0) {
    case /* PrepareWrkPrecalcData */0 :
        return "PrepareWrkPrecalcData";
    case /* SetSettings */1 :
        return "SetSettings(settingsVer=" + String(req.settingsVer) + ")";
    case /* SetPreCtx */2 :
        return "SetPreCtx(preCtxVer=" + String(req.preCtxVer) + ")";
    
  }
}

function respToStr(resp) {
  if (typeof resp === "number") {
    return "Ok";
  } else if (resp.TAG === /* GetSettings */0) {
    return "GetSettings(settingsVer=" + String(resp.settingsVer) + ")";
  } else {
    return "GetPreCtx(preCtxVer=" + String(resp.preCtxVer) + ")";
  }
}

var wrkPrecalcData = {
  contents: undefined
};

function getWrkCtxExn(param) {
  var match = wrkPrecalcData.contents;
  if (match !== undefined) {
    return match.wrkCtx;
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "wrkCtx is not created in the worker thread."
        },
        Error: new Error()
      };
}

function getWrkParenCntExn(param) {
  var match = wrkPrecalcData.contents;
  if (match !== undefined) {
    return match.wrkParenCnt;
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "wrkParenCnt is not created in the worker thread."
        },
        Error: new Error()
      };
}

function getWrkFrmsExn(param) {
  var match = wrkPrecalcData.contents;
  if (match !== undefined) {
    return match.wrkFrms;
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "wrkFrms is not created in the worker thread."
        },
        Error: new Error()
      };
}

var settingsCache = Common.cacheMake((function (settings) {
        return settings;
      }), (function (v1, v2) {
        return v1 === v2;
      }));

var preCtxCache = Common.cacheMake((function (ctx) {
        return ctx;
      }), (function (v1, v2) {
        return v1 === v2;
      }));

var frmsCache = Common.cacheMake((function (param) {
        return MM_substitution.prepareFrmSubsData(param[1], undefined);
      }), (function (param, param$1) {
        if (param[0] === param$1[0]) {
          return param[1] === param$1[1];
        } else {
          return false;
        }
      }));

var parenCntCache = Common.cacheMake((function (param) {
        return MM_provers.makeParenCnt(param[1], param[0].parens);
      }), (function (param, param$1) {
        if (param[0] === param$1[0]) {
          return param[1] === param$1[1];
        } else {
          return false;
        }
      }));

function makeWrkPrecalcData(settingsVer, preCtxVer, varsText, disjText) {
  var settings = Common.cacheGetByDepVer(settingsCache, settingsVer);
  if (settings === undefined) {
    return {
            TAG: /* Error */1,
            _0: {
              TAG: /* GetSettings */0,
              settingsVer: settingsVer
            }
          };
  }
  var preCtx = Common.cacheGetByDepVer(preCtxCache, preCtxVer);
  if (preCtx === undefined) {
    return {
            TAG: /* Error */1,
            _0: {
              TAG: /* GetPreCtx */1,
              preCtxVer: preCtxVer
            }
          };
  }
  var preCtx$1 = Caml_option.valFromOption(preCtx);
  var wrkCtx = MM_wrk_ctx_data.createWrkCtx(preCtx$1, varsText, disjText);
  if (wrkCtx.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              wrkFrms: Common.cacheGet(frmsCache, [
                    settingsVer,
                    preCtxVer
                  ], [
                    settings,
                    preCtx$1
                  ]),
              wrkParenCnt: Common.cacheGet(parenCntCache, [
                    settingsVer,
                    preCtxVer
                  ], [
                    settings,
                    preCtx$1
                  ]),
              wrkCtx: wrkCtx._0
            }
          };
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "There was an error creating wrkCtx in the worker thread."
        },
        Error: new Error()
      };
}

function processOnWorkerSide(req, sendToClient) {
  switch (req.TAG | 0) {
    case /* PrepareWrkPrecalcData */0 :
        wrkPrecalcData.contents = undefined;
        var resp = makeWrkPrecalcData(req.settingsVer, req.preCtxVer, req.varsText, req.disjText);
        if (resp.TAG !== /* Ok */0) {
          return Curry._1(sendToClient, resp._0);
        }
        wrkPrecalcData.contents = resp._0;
        return Curry._1(sendToClient, /* Ok */0);
    case /* SetSettings */1 :
        Common.cacheGet(settingsCache, req.settingsVer, req.settings);
        return ;
    case /* SetPreCtx */2 :
        Common.cacheGet(preCtxCache, req.preCtxVer, req.preCtx);
        return ;
    
  }
}

function beginWorkerInteractionUsingCtx(settingsVer, settings, preCtxVer, preCtx, varsText, disjText, procName$1, initialRequest, onResponse, enableTraceOpt, param) {
  var enableTrace = enableTraceOpt !== undefined ? enableTraceOpt : false;
  var prepareWrkPrecalcDataReq = {
    TAG: /* PrepareWrkPrecalcData */0,
    settingsVer: settingsVer,
    preCtxVer: preCtxVer,
    varsText: varsText,
    disjText: disjText
  };
  MM_wrk_client.beginWorkerInteraction(procName, prepareWrkPrecalcDataReq, (function (resp, sendToWorker, endWorkerInteraction) {
          if (typeof resp !== "number") {
            if (resp.TAG === /* GetSettings */0) {
              if (resp.settingsVer === settingsVer) {
                Curry._1(sendToWorker, {
                      TAG: /* SetSettings */1,
                      settingsVer: settingsVer,
                      settings: settings
                    });
                return Curry._1(sendToWorker, prepareWrkPrecalcDataReq);
              } else {
                return ;
              }
            } else if (resp.preCtxVer === preCtxVer) {
              Curry._1(sendToWorker, {
                    TAG: /* SetPreCtx */2,
                    preCtxVer: preCtxVer,
                    preCtx: preCtx
                  });
              return Curry._1(sendToWorker, prepareWrkPrecalcDataReq);
            } else {
              return ;
            }
          }
          Curry._1(endWorkerInteraction, undefined);
          MM_wrk_client.beginWorkerInteraction(procName$1, initialRequest, onResponse, enableTrace, undefined, undefined, undefined);
        }), enableTrace, undefined, undefined, undefined);
}

exports.procName = procName;
exports.beginWorkerInteractionUsingCtx = beginWorkerInteractionUsingCtx;
exports.getWrkCtxExn = getWrkCtxExn;
exports.getWrkParenCntExn = getWrkParenCntExn;
exports.getWrkFrmsExn = getWrkFrmsExn;
exports.processOnWorkerSide = processOnWorkerSide;
exports.reqToStr = reqToStr;
exports.respToStr = respToStr;
/* settingsCache Not a pure module */
